module.exports = __webpack_public_path__ + "static/media/3.80a83bf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/landing/reviews/3.png
// module id = 1723
// module chunks = 0